module.exports = __webpack_public_path__ + "web/static/img/legrand.7413c363.png";